import react, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody'; import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Fab from '@mui/material/Fab';
import DownloadIcon from '@mui/icons-material/Download';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Pagination from "react-js-pagination";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import swal from 'sweetalert';
import { get_categories_forAll_services, get_products, get_suppliers } from "../../../services/for_allServices";
import Loading_animation_view from "../../loading_animation_view/loading_animation_view";


const columns = [
    { id: 'product_code', label: "Code produit", minWidth: 0 },
    { id: 'supplier', label: "Fournisseur", minWidth: 0 },
    { id: 'product_name', label: "Produit de référence", minWidth: 0 },
    { id: 'product_category', label: "Famille d'achat", minWidth: 0 },
    { id: 'product_price', label: "Prix", minWidth: 0 },
    { id: 'archived', label: "Archiver", minWidth: 0 },
];

function numberWithSpaces(x) {
   if(x) return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  else return x;
}


const Products_data = ({ product, id_product, get_category_name_by_id, get_supplier_by_id, view_product_details, handleDeleteClick }) => {

    return (
        <>
            <TableCell>
                <span style={{ textDecoration: "underLine", color: "blue", cursor: "pointer" }} onClick={() => view_product_details(product, id_product)}>
                    {product.product_code}
                </span>
            </TableCell>
            <TableCell>{product.id_supplier ? get_supplier_by_id(product.id_supplier) : "Aucun"}</TableCell>
            <TableCell> {product.title} </TableCell>
            <TableCell> {get_category_name_by_id(product.id_category)} </TableCell>
            <TableCell>{numberWithSpaces(product.product_price)+" MAD"}</TableCell>
            <TableCell>
                <Tooltip title="Archiver">
                    <DeleteForeverIcon style={{ color: 'red' }} onClick={() => handleDeleteClick({ product_reference: product.product_reference, product_code: product.product_code })} />
                </Tooltip>
            </TableCell>
        </>
    )
}


const Products_list = () => {
    let history = useHistory();

    const [suppliers, setsuppliers] = useState([]);
    const [categories, setCategories] = useState([]);

    const [products, setProducts] = useState(null);

    const [update_product_infos, setupdate_product_infos] = useState(null);
    const [open_addProduct_to_stock_modal, setopen_addProduct_to_stock_modal] = useState(false);
    const [open_importProducts_to_stock_modal, setopen_importProducts_to_stock_modal] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setdataPerPage] = useState(5);
    const [data_count, setdata_count] = useState(0);

    const [url_updated, setUrl_updated] = useState(null);
    const [waiting, setWaiting] = useState(false);


    useEffect(() => {
        setProducts(null);
        setdata_count(0);
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var tmp_searchValue = "null";
        var tmp_filterSupplier = "all";
        var tmp_filterCategorie = "all";
        const page = urlParams.get('page') ? urlParams.get('page') : 1;

        setCurrentPage(Number(page));

        const load_data = async () => {
            let page = (urlParams.get('page') ? urlParams.get('page') : 1);
            await setCurrentPage(page);
            await get_suppliers().then((response) => {
                console.log("load_data : ", response.data);
                setsuppliers(response.data);
            }).catch((error) => {
                console.log(error.response);
            })
            await get_categories_forAll_services().then((response) => {
                setCategories(response.data);
            }).catch((error) => {
                //console.log(error.response);
            });


            get_products(tmp_filterCategorie, tmp_filterSupplier, tmp_searchValue, page).then((response) => {
                setProducts(response.data.data);
                setdata_count(response.data.total);
                console.log("==", response.data);
            }).catch((error) => {
                console.log(error.response);
            });
        }
        load_data();

    }, [url_updated]);


    function get_category_name_by_id(id_category) {
        let tmp_name = "";
        for (let category of categories) {
            if (category.id_category == parseInt(id_category)) tmp_name = category.name;
        }
        return tmp_name;
    }


    function get_supplier_by_id(id) {
        //  console.log("suppli")
        let tmp_supplier = "";
        for (let supplier of suppliers) {
            if (supplier.id == id) { tmp_supplier = supplier.fullName; break; }
        }
        return tmp_supplier;
    }

    async function view_product_details(product, id_stock_product, id_products_by_supplier) {
        setupdate_product_infos({ "product": product, "id_stock_product": id_stock_product, "id_products_by_supplier": id_products_by_supplier });
        setopen_addProduct_to_stock_modal(true);
    }


    const handleDelete = async (deletePayload) => {
        swal({
            title: "Confirmer l'archivage",
            text: "Êtes-vous sûr de vouloir archiver ce fournisseur ?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (isConfirm) => {
            if (isConfirm) {
                /*  try {
                      console.log("reference", deletePayload.product_reference, "code", deletePayload.product_code);
                      const response = await delete_from_stock(deletePayload);
                      console.log("message", response.data);
  
                      await load_stock_data();
  
                      swal("Archivé !", "Le fournisseur a été archivé avec succès.", "success");
                  } catch (error) {
                      console.error("Erreur lors de la suppression :", error.response);
                      swal("Erreur", "L'archivage a échoué.", "error");
                  }*/
            }
        });
    };

    const handleDeleteClick = (payload) => {
        handleDelete(payload); // appelle directement la confirmation swal
    };



    async function change_page(page) {
        setCurrentPage(page); // Mise à jour de la page
        let path = history.location.pathname;
        let params = history.location.search;
        let search_params = params.split('&');
        let tmp_params = path;

        if (!params) {
            history.push(path + "?page=" + page);
        } else {
            for (let i in search_params) {
                if (search_params[i].includes("page=")) {
                    search_params[i] = "page=" + page;
                }
            }
            tmp_params = path + "?" + search_params.join('&');
            if (!tmp_params.includes("page=")) {
                tmp_params += "&page=" + page;
            }
            history.push(tmp_params);
        }
    }


    return (
        <>
            {
                products == null
                    ? <Loading_animation_view />
                    : <div className='stock_list_container'>
                        <div className="products_gallery_header_container">
                            <div style={{ marginRight: '7px', display: 'flex' }}>
                                <Tooltip title="Ajouter">
                                    <Fab className="add_new_object_fab add_new_object_fab_big" onClick={() => setopen_addProduct_to_stock_modal(true)} >
                                        <AddIcon className="my_icon" />
                                    </Fab>
                                </Tooltip>

                                <Tooltip title="Importer">
                                    <Fab className="add_new_object_fab add_new_object_fab_big" onClick={() => setopen_importProducts_to_stock_modal(true)}>
                                        <DownloadIcon className="my_icon" />
                                    </Fab>
                                </Tooltip>
                            </div>

                        </div>
                        <div className="commissions_table_container">
                            <TableContainer>
                                <Table aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {
                                                columns.map((column) => (
                                                    <TableCell key={column.id} align="left">{column.label}</TableCell>
                                                ))
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            products.length !== 0
                                                ?
                                                <>
                                                    {
                                                        products.map((product, id_product) => (
                                                            <TableRow key={"product " + id_product}>
                                                                <Products_data product={product} id_product={id_product} view_product_details={view_product_details}
                                                                    get_category_name_by_id={get_category_name_by_id}
                                                                    get_supplier_by_id={get_supplier_by_id}
                                                                    handleDeleteClick={handleDeleteClick} />
                                                            </TableRow>
                                                        ))
                                                    }
                                                </>

                                                : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucun produit disponible</div>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {
                                products.length !== 0
                                    ? <div className="pagination_container">
                                        <Pagination
                                            activePage={Number(currentPage)}
                                            itemsCountPerPage={dataPerPage}
                                            totalItemsCount={Number(data_count)}
                                            pageRangeDisplayed={4}
                                            onChange={change_page.bind(this)}
                                        />
                                    </div>
                                    : <></>
                            }
                        </div>
                    </div>
            }
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default Products_list;